module.exports = __webpack_public_path__ + "static/media/resume.ec019f1b.pdf";